export function isSxArray<T>(object: unknown): object is Extract<T, ReadonlyArray<unknown>> {
  return Array.isArray(object);
}
